import { TradingOffer, TradingOfferStatus } from '../../../types/TradingOffer';

export const getOfferStatus = (offer: TradingOffer): TradingOfferStatus => {
  const now = new Date();
  const endDate = new Date(offer.endDate);

  if (endDate < now) {
    return TradingOfferStatus.EXPIRED;
  }

  if (offer.sharesCount.agreed === offer.sharesCount.total) {
    return TradingOfferStatus.ACCEPTED;
  }

  return TradingOfferStatus.ACTIVE;
};

export const isOfferExpired = (offer: TradingOffer): boolean => {
  const status = getOfferStatus(offer);
  return status === TradingOfferStatus.EXPIRED;
};

export const isOfferAccepted = (offer: TradingOffer): boolean => {
  const status = getOfferStatus(offer);
  return status === TradingOfferStatus.ACCEPTED;
};

export const isOfferActive = (offer: TradingOffer): boolean => {
  const status = getOfferStatus(offer);
  return status === TradingOfferStatus.ACTIVE;
};

/**
 * Ofertas de venta que siguen ocupando participaciones del socio para nuevas propuestas
 * (ej. máximo transferible por clase): activas en mercado y aceptadas al 100%.
 * No incluye EXPIRED.
 */
export const isOfferReservingPartnerShares = (offer: TradingOffer): boolean => {
  const status = getOfferStatus(offer);
  return (
    status === TradingOfferStatus.ACTIVE ||
    status === TradingOfferStatus.ACCEPTED
  );
};
